import React  from "react";
import './feature.scss'
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import "chartjs-plugin-datalabels";


export default function Feature({ChartList}) {
  return (
    <div className='feature'>
        <div className="top">
          <h1 className="title">จำนวนลูกค้าทั้งหมด</h1>
          </div>
          <div style={{height:"60vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
              <Doughnut width={"30%"}
                  data={{
                        datasets: [{
                          label: 'จำนวนลูกค้าทั้งหมด',
                          data: ChartList.map( (person) => person.Value),
                          backgroundColor: [
                            '#f48fb1',
                            '#81d4fa',
                            '#ffb74d',
                            '#69f0ae'
                          ],
                          borderWidth: 1,
                          hoverOffset: 10
                        }],
                        labels: ChartList.map( person => person.TypeCus)
                       }}
                       options= {{maintainAspectRatio: false}}
                       />
          </div>
                  
          </div>
  )
}